angular.module('mychart').factory('MyChartService',
    ['GuidList', 'PatientSettingsService', 'PersonRepository', '$q', 'aprgettext', 'ConsentService',
        function MyChartService(GuidList, PatientSettingsService, PersonRepository, $q, gettext, ConsentService) {
            'use strict';

            var myChartConfigList,
                userId,
                patientDetails,
                userFullName,
                immunizations = {
                    Results: '',
                    VaccineCardTypeId: ''
                },
                documents,
                problems,
                procedures,
                labResults,
                newLabResults,
                visitSummaries,
                appointments,
                referenceMaterial,
                medicationAllergies,
                mychartServiceUserId;

            function createUpdateDetailsDto() {
                return _.cloneDeep(patientDetails).value();
            }

            function getMyChartConfig() {
                if (!myChartConfigList) {
                    var featureList = PatientSettingsService.getPatientFeatures();
                    myChartConfigList = {
                        'PatientDocuments': {'Name': 'View Patient Documents', Id: 'mychart_documents', LabelName: gettext('Problems'), Route: 'myChartPatientDocuments', IsActive: featureList.ViewMedicalHistory.IsActive},
                        'ViewClinicalSummary': {'Name': 'View Clinical Summary', 'Uid': GuidList.FeatureList.ViewClinicalSummary,
                            Id: 'mychart_visitsummaries', LabelName: gettext('Visit Summaries'), Route: 'myChartVisitSummary',
                            'IsActive': featureList.ViewClinicalSummary.IsActive},
                        'ViewDocuments': {'Name': 'View Documents', 'Uid': GuidList.FeatureList.ViewDocuments,
                            Id: 'mychart_documents', LabelName: gettext('Documents'), Route: 'myChartDocuments',
                            'IsActive': featureList.ViewDocuments.IsActive},
                        'ViewProblems': {Id: 'mychart_problems', LabelName: gettext('Problems'), Route: 'myChartProblems', IsActive: featureList.ViewMedicalHistory.IsActive},
                        'ViewMedications': {'Name': 'View Medications', 'Uid': GuidList.FeatureList.ViewMedications,
                            Id: 'mychart_prescriptions', LabelName: gettext('Prescriptions'), Route: 'myChartPrescriptions',
                            'IsActive': featureList.ViewMedications.IsActive},
                        'ViewProcedures': {'Name': 'View Procedures', 'Uid': GuidList.FeatureList.ViewProcedures,
                            Id: 'mychart_procedures', LabelName: gettext('Procedures'), Route: 'myChartProcedures',
                            'IsActive': featureList.ViewProcedures.IsActive},
                        'ViewImmunizations': {
                            Name: 'View Immunizations',
                            Uid: GuidList.FeatureList.ViewImmunizations,
                            Id: 'mychart_immunizations',
                            LabelName: gettext('Immunizations'),
                            Route: 'myChartImmunizations',
                            IsActive: featureList.ViewImmunizations.IsActive,
                            Config: {
                                Pediatric: featureList.ViewImmunizations.ImmunizationsConfig && featureList.ViewImmunizations.ImmunizationsConfig.Pediatric,
                                Adult: featureList.ViewImmunizations.ImmunizationsConfig && featureList.ViewImmunizations.ImmunizationsConfig.Adult,
                                Misc: featureList.ViewImmunizations.ImmunizationsConfig &&featureList.ViewImmunizations.ImmunizationsConfig.Misc
                            }
                        },
                        'ViewLabResults': {'Name': 'View Test Results', 'Uid': GuidList.FeatureList.ViewLabTestResults,
                            Id: 'mychart_labresults', LabelName: gettext('Test Results'), Route: 'myChartLabResults',
                            'IsActive': featureList.ViewLabTestResults.IsActive},
                        'ViewEducationMaterial': {'Name': 'View Education Material', 'Uid': GuidList.FeatureList.ViewEducationMaterial,
                            Id: 'mychart_referencematerial', LabelName: gettext('Educational Material'), Route: 'myChartReferenceMaterial',
                            'IsActive': featureList.ViewEducationMaterial.IsActive},
                        'UpdateDemographics': {'Name': 'Update Demographics', 'Uid': GuidList.FeatureList.UpdateDemographics,
                            Id: 'mychart_personaldetails', LabelName: gettext('Personal Details'), Route: 'myChartPersonalDetails',
                            'IsActive': featureList.UpdateDemographics.IsActive},
                        'UpdateInsurance': featureList.UpdateInsurance,
                        'ViewMedicationAllergies': {'Name': 'View Medication Allergies', 'Uid': GuidList.FeatureList.ViewMedicationAllergies,
                            Id: 'mychart_medicationallergies', LabelName: gettext('Medication Allergies'), Route: 'myChartMedicationAllergies',
                            'IsActive': featureList.ViewMedicationAllergies.IsActive},
                        'RequestRxRefills': featureList.RequestRxRefills,
                        'ViewCompleteChart': featureList.ViewCompleteChart,
                        'AllowGenerateCCD' : featureList.AllowGenerateCCD
                    };
                }
                return $q.when(myChartConfigList);
            }

            function getDetails(patientId, forceUpdate) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!patientDetails || forceUpdate) {
                    return PersonRepository.getDetails(patientId)
                        .then(function (data) {
                            patientDetails = data;
                            return patientDetails;
                        });
                } else {
                    return $q.when(patientDetails);
                }
            }

            function getPatientDetailsMetadata($scope) {
                return PersonRepository.getPatientDetailsMetadata($scope);
            }

            function updateDetails(userId, dto) {
                return PersonRepository.updateDetails(userId, dto)
                    .then(function (data) {
                        patientDetails = data;
                        return patientDetails;
                    });
            }

            function searchPharmacies(zip, phoneNumber) {
                return PersonRepository.searchPharmacies(mychartServiceUserId, zip, phoneNumber);
            }

            function loadMyChart(patientId) {
                return $q.all([getDetails(patientId), getMyChartConfig()]);
            }           

            function getImmunizations(patientId, vaccineCardTypeId, forceRefresh) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }

                if (!immunizations || immunizations.VaccineCardTypeId !== vaccineCardTypeId || forceRefresh) {
                    return PersonRepository.getImmunizations(patientId, vaccineCardTypeId)
                        .then(function (data) {
                            immunizations.Results = data;
                            immunizations.VaccineCardTypeId = vaccineCardTypeId;
                            return immunizations;
                        });
                }

                return $q.when(immunizations);
            }

            function getProblems(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!problems) {
                    return PersonRepository.getProblems(patientId)
                        .then(function (data) {
                            problems = data;
                            return problems;
                        });
                } else {
                    return $q.when(problems);
                }
            }

            function getProcedures(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!procedures) {
                    return PersonRepository.getProcedures(patientId)
                        .then(function (data) {
                            procedures = data;
                            return procedures;
                        });
                } else {
                    return $q.when(procedures);
                }
            }

            function getNewLabResults(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                return PersonRepository.getNewLabResults(patientId)
                    .then(function (data) {
                        newLabResults = data;
                        return newLabResults;
                    });
            }

            function getLabResults(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!labResults) {
                    return PersonRepository.getLabResults(patientId)
                        .then(function (data) {
                            labResults = data;
                            return labResults;
                        });
                } else {
                    return $q.when(labResults);
                }
            }

            function getVisitSummaries(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!visitSummaries) {
                    return PersonRepository.getVisitSummaries(patientId)
                        .then(function (data) {
                            visitSummaries = data;
                            return visitSummaries;
                        });
                } else {
                    return $q.when(visitSummaries);
                }
            }

            function getAppointments(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!appointments) {
                    return PersonRepository.getAppointments(patientId)
                        .then(function (data) {
                            appointments = data;
                            return appointments;
                        });
                } else {
                    return $q.when(appointments);
                }
            }

            function getReferenceMaterial(reportRequestDto) {
                if (reportRequestDto.PatientId !== mychartServiceUserId) {
                    resetMyChart(reportRequestDto.PatientId);
                }
                if (!referenceMaterial) {
                    return PersonRepository.getReferenceMaterial(reportRequestDto)
                        .then(function (data) {
                            referenceMaterial = data;
                            return referenceMaterial;
                        });
                } else {
                    return $q.when(referenceMaterial);
                }
            }

            function getMedicationAllergies(patientId) {
                if (patientId !== mychartServiceUserId) {
                    resetMyChart(patientId);
                }
                if (!medicationAllergies) {
                    return PersonRepository.getMedicationAllergies(patientId)
                        .then(function (data) {
                            medicationAllergies = data;
                            return medicationAllergies;
                        });
                } else {
                    return $q.when(medicationAllergies);
                }
            }

            function getBilling(patientId) {
                return PersonRepository.getBilling(patientId)
                    .then(function (data) {
                        return data;
                    });
            }

            function getFemaleThumbnailSrc(height, width) {
                if (height && !width) {
                    width = height;
                }

                var url = 'person/thumbnail/?type=female';

                if (height) {
                    url += '&height=' + height + '&width=' + width;
                }

                return url;
            }

            function getMaleThumbnailSrc(height, width) {
                if (height && !width) {
                    width = height;
                }

                var url = 'person/thumbnail/?type=male';

                if (height) {
                    url += '&height=' + height + '&width=' + width;
                }

                return url;
            }

            function clearAll() {
                userId = null;
                patientDetails = null;
                userFullName = null;
                immunizations = {
                    Results: '',
                    VaccineCardTypeId: ''
                };
                documents = null;
                problems = null;
                procedures = null;
                labResults = null;
                newLabResults = null;
                visitSummaries = null;
                appointments = null;
                referenceMaterial = null;
                medicationAllergies = null;

                ConsentService.clearChartConsent();
            }

            function setBillingServiceUserId(patientId){
                mychartServiceUserId = patientId;
            }

            function resetMyChart(patientId){
                clearAll();
                setBillingServiceUserId(patientId);
            }

            function auditImmunizationLogging(requestReportDto) {
                return PersonRepository.postImmunizationAudit(requestReportDto);
            }

            function auditClinicalSummaryLogging(requestReportDto) {
                return PersonRepository.postClinicalSummaryAudit(requestReportDto);
            }

            function auditDemographicsLogging(requestReportDto) {
                return PersonRepository.postDemographicsAudit(requestReportDto);
            }

            function auditLabResultsLogging(requestReportDto) {
                return PersonRepository.postLabResultAudit(requestReportDto);
            }

            function auditMedicalHistoryLogging(requestReportDto) {
                return PersonRepository.postMedicalHistoryAudit(requestReportDto);
            }

            function auditMedicationAllergiesLogging(requestReportDto) {
                return PersonRepository.postMedicationAllergiesAudit(requestReportDto);
            }

            function auditProceduresLogging(requestReportDto) {
                return PersonRepository.postProcedureAudit(requestReportDto);
            }

            function auditEducationMaterialLogging(requestReportDto) {
                return PersonRepository.postEducationalMaterialAudit(requestReportDto);
            }

            function auditChartLogging(requestReportDto) {
                return PersonRepository.postChartAudit(requestReportDto);
            }

            function usageMetricLogging(updateUsageMetricDto) {
                return PersonRepository.postUsageMetricUpdate(updateUsageMetricDto);
            }            

            return {
                loadMyChart: loadMyChart,
                getMyChartConfig: getMyChartConfig,
                getDetails: getDetails,
                getPatientDetailsMetadata: getPatientDetailsMetadata,
                updateDetails: updateDetails,
                createUpdateDetailsDto: createUpdateDetailsDto,
                getImmunizations: getImmunizations,
                getProblems: getProblems,
                getProcedures: getProcedures,
                getNewLabResults: getNewLabResults,
                getLabResults: getLabResults,
                getVisitSummaries: getVisitSummaries,
                getAppointments: getAppointments,
                searchPharmacies: searchPharmacies,
                getBilling: getBilling,
                getReferenceMaterial: getReferenceMaterial,
                getMedicationAllergies: getMedicationAllergies,
                getFemaleThumbnailSrc: getFemaleThumbnailSrc,
                getMaleThumbnailSrc: getMaleThumbnailSrc,
                clearAll: clearAll,
                auditImmunizationLogging: auditImmunizationLogging,
                auditClinicalSummaryLogging : auditClinicalSummaryLogging,
                auditDemographicsLogging : auditDemographicsLogging,
                auditLabResultsLogging : auditLabResultsLogging,
                auditMedicalHistoryLogging :  auditMedicalHistoryLogging,
                auditMedicationAllergiesLogging : auditMedicationAllergiesLogging,
                auditProceduresLogging : auditProceduresLogging,
                auditEducationMaterialLogging : auditEducationMaterialLogging,
                auditChartLogging : auditChartLogging,
                usageMetricLogging: usageMetricLogging
            };
        }]);
